export const BuildingSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 19"
    aria-hidden="true"
    role="presentation"
    width={24}
    height={24}
  >
    <rect x="3.13" y="9.13" width="1.33" height="2.02" />
    <rect x="6.2" y="9.13" width="1.33" height="2.02" />
    <rect x="3.13" y="4.31" width="1.33" height="2.04" />
    <rect x="6.2" y="4.31" width="1.33" height="2.04" />
    <path
      fill="currentColor"
      d="M18.6,7H10.67V1.4A1.41,1.41,0,0,0,9.27,0H1.4A1.4,1.4,0,0,0,0,1.4v19H20v-12A1.4,1.4,0,0,0,18.6,7ZM4.42,19.07V15.84H6.24v3.23Zm4.91,0H7.58V15.43a.93.93,0,0,0-.91-.93H4a.93.93,0,0,0-.92.93v3.64H1.33V1.4a.07.07,0,0,1,.06-.07H9.27a.06.06,0,0,1,.06.06h0V19.07Zm4.4,0V15.84h1.82v3.23Zm4.93,0H16.89V15.43A.93.93,0,0,0,16,14.5H13.32a.93.93,0,0,0-.92.93v3.64H10.67V8.29H18.6a.07.07,0,0,1,.07.07h0Z"
    />
    <rect x="12.47" y="10.13" width="1.33" height="2.02" />
    <rect x="15.53" y="10.13" width="1.33" height="2.02" />
  </svg>
)
export default BuildingSvg
